import { Table, TableCell, Paper, Box, styled } from '@mui/material';
import { TextField } from '@totalsoft/rocket-ui';
import { StyledHeaderCell } from 'components/common/Styles';

// #region Risks

export const RisksNumericHeaderCell = styled(StyledHeaderCell)(({ theme }) => ({
  [theme.breakpoints.up(1400)]: {
    width: '10%'
  },
  [theme.breakpoints.down(1400)]: {
    width: '13%'
  }
}));

export const RisksCheckboxHeaderCell = styled(StyledHeaderCell)(({ theme }) => ({
  [theme.breakpoints.up(1400)]: {
    width: '10%'
  },
  [theme.breakpoints.down(1400)]: {
    width: '8%'
  }
}));

// #endregion

// #region Percent calculation - Generic filter param table

export const StyledPhrasePaper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: theme.spacing(1.5),
  backgroundColor: theme.palette.grey[100]
}));

export const StyledLabelContainer = styled(Box, { shouldForwardProp: prop => prop !== 'error' })(({ theme, error }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  color: error ? theme.palette.error.main : theme.palette.grey[600],
  '& .MuiSvgIcon-root': {
    width: theme.spacing(2),
    height: theme.spacing(2)
  }
}));

export const StyledPhraseTextField = styled(TextField)(({ theme, error }) => ({
  '& .MuiInput-input::placeholder': {
    color: error ? theme.palette.error.main : 'auto'
  }
}));

export const GenericFilterParamTable = styled(Table)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: '10px',
  boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)'
}));

export const GenericFilterParamTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  paddingBlock: theme.spacing(3),
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
}));

// #endregion
